module.exports = "/_next/static/images/24547f22f5797b05ca889c7228d1612c-hero-desktop.jpg.webp";